import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// import SystemDashboard from 'layouts/SystemDashboard';
// import {
//   getAllItems,
//   deleteItem,
//   // getItem,
//   // saveItem,
//   // updateItem,
// } from './ItemService';
import { getAllQuestionsByItem, removeQuestionToItem } from './ItemService';
import AttachItemQuestion from './AttachItemQuestion';

// import { getAllItemsByParent, removeItemToParent } from './ItemService';
// import { getSection } from '../Sections/SectionService';

import {
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // Box,
  // Breadcrumbs,
  // Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Container from 'components/Container';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const ItemQuestionList = ({ itemId }): JSX.Element => {
  // const theme = useTheme();

  const [questions, setQuestions] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [questionIdToDelete, setQuestionIdToDelete] = useState(null);

  const { itemid } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    listItemQuestions();

    return () => {};
  }, [itemId]);

  function listItemQuestions() {
    setLoading(true);
    getAllQuestionsByItem(itemid)
      .then((response) => {
        setQuestions(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function selectQuestion(questionid) {
    console.log(questionid);
    navigate(`/system/dashboard/question/${questionid}`);
  }

  // function updateAttachment(attachmentid) {
  //   console.log(attachmentid);
  //   navigate(`/update-attachment/${attachmentid}`);
  // }

  const handleDeleteConfirmation = (questionid) => {
    setQuestionIdToDelete(questionid);
    setOpenDialog(true);
  };

  const handleDeleteQuestion = () => {
    // Call your removeItem function to delete the item
    removeQuestion(itemid, questionIdToDelete);
    // Close the dialog
    setOpenDialog(false);
  };

  function removeQuestion(itemid, questionid) {
    removeQuestionToItem(itemid, questionid)
      .then(() => {
        // Item deleted successfully, update the list
        listItemQuestions();
      })
      .catch((error) => {
        // Handle errors or exceptions
        if (error.response) {
          // The request was made and the server responded with a status code
          // Display an error message based on the response status
          console.error(
            'Request failed with status code:',
            error.response.status,
          );
          // Check if the error is due to a foreign key constraint violation
          if (
            error.response.status === 400 &&
            typeof error.response.data === 'string' &&
            error.response.data.includes('foreign key constraint')
          ) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete the item because it is referenced by other records.',
            );
          }
          if (error.response.status === 401) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete or update a parent row: a foreign key constraint fails.',
            );
          } else {
            // Display a generic error message for other types of errors
            notify(
              'An error occurred while deleting the item. Please try again later.',
            );
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error(
            'Request made but no response received:',
            error.request,
          );
        } else {
          // Something happened in setting up the request that triggered an error
          console.error('Error setting up the request:', error.message);
        }
      });
  }

  return (
    <Container>
      {/* <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Typography color="text.primary">{pageTitle}</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">{pageTitle}</Typography>
          <Button variant="contained" onClick={addItem}>
            Add Item
          </Button>
        </Box>
        
      </SystemDashboard> */}

      {loading && <p>Loading...</p>}
      {/* <AttachChildren
        listItemChildren={listItemChildren}
        parentId={parentId}
        sectionId={sectionId}
      /> */}
      <AttachItemQuestion
        listItemQuestions={listItemQuestions}
        itemId={itemid}
      />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: 'alternate.main' }}>
            <TableRow>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  ID
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Question Content
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Status
                </Typography>
              </TableCell>
              <TableCell />
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
              <DialogTitle>Confirm Deletion</DialogTitle>
              <DialogContent>
                Are you sure you want to remove this question?
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                <Button onClick={handleDeleteQuestion} autoFocus>
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
            {questions.map((item, i) => (
              <TableRow
                key={i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                onClick={() => selectQuestion(item.id)}
              >
                <TableCell>
                  <Typography>{item.id}</Typography>
                  {/* <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.id}
                  </Typography> */}
                </TableCell>
                <TableCell>
                  <Typography>{item.questionContent}</Typography>
                  {/* <Typography color={'text.secondary'} variant={'subtitle2'}>
                    Example Answer: {item.exampleAnswer}
                  </Typography> */}
                </TableCell>
                <TableCell>
                  <Typography>{item.status}</Typography>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.status}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'primary'}
                    variant={'subtitle2'}
                    fontWeight={700}
                    sx={{ cursor: 'pointer' }}
                  >
                    Edit
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'primary'}
                    variant={'subtitle2'}
                    fontWeight={700}
                    sx={{ cursor: 'pointer' }}
                  >
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation(); // Stop the click event from propagating
                        handleDeleteConfirmation(item.id); // Show confirmation dialog before deleting
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ItemQuestionList;
